<template>
    <div class="recharge_detail-container">
        <div class="detail-title-wrap">
            <span class="detail-title">油卡充值</span>
        </div>
        <order-detail :order-id="orderId" :order-type="0" @pass-data="passData"></order-detail>
    </div>
</template>

<script>
    import OrderDetail from './OrderDetail'

    export default {
        name: 'RechargeDetail',
        components: {OrderDetail},
        data () {
            return {
                rechargeInfo: {},
                orderId: ''
            }
        },
        methods: {
            // 子组件传递数据给父组件
            passData (data) {
                this.rechargeInfo = data
            }
        }
    }
</script>

<style lang="scss" scoped>
    .recharge_detail-container {
        .detail-title-wrap {
            padding: 16px 20px 8px;

            .detail-title {
                margin-bottom: 10px;
                color: #333333;
                background: #ffffff;
                font-size: 16px;
                font-weight: bold;
                border-bottom: #ebedf0 solid 1px;
                vertical-align: middle;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/RechargeDetail.vue